import { getToken } from "../utils/auth";
import TRACK_ACTIVITY from "./endpoints/trackActivityEndpoint";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:1111";

/**
 * Reliable "page exit" activity ping.
 *
 * When the page is being hidden or torn down (tab close, navigation, mobile
 * backgrounding), a normal axios/XHR request is frequently cancelled before it
 * reaches the server, so the final segment of time-on-page is lost. We send it
 * with `fetch(..., { keepalive: true })`, which the browser is required to keep
 * alive and complete even after the page unloads.
 *
 * We use fetch + keepalive rather than navigator.sendBeacon because this API
 * authenticates via the `x-access-token` header, and sendBeacon cannot set
 * custom request headers (it would send the ping unauthenticated → 401).
 *
 * Payload is just { page_name }; the backend derives the duration from the
 * session's enter_time, so this stays in seconds like every other ping.
 *
 * @param {string} pageName - e.g. "DASHBOARD"
 */
export const sendActivityPingBeacon = (pageName) => {
  // Mirror the redux thunks' isLoggedIn() guard so we never fire tokenless 401s.
  const token = getToken();
  if (!token || !pageName) return;

  try {
    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };
    const sessionId = sessionStorage.getItem("sessionId");
    if (sessionId) headers["x-session-id"] = sessionId;

    fetch(`${API_BASE_URL}${TRACK_ACTIVITY.activityPing}`, {
      method: "POST",
      keepalive: true,
      headers,
      body: JSON.stringify({ page_name: pageName }),
    }).catch(() => {
      // Swallow errors — this fires during page teardown and must never throw.
    });
  } catch (e) {
    // Never let activity tracking break a page unload.
  }
};

export default sendActivityPingBeacon;
